import { useNavigate } from "react-router-dom";
import { BrandMark } from "@/components/base/BrandLogo";

export default function Footer() {
  const navigate = useNavigate();

  const handleNav = (path: string) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-stone-900 text-white">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <BrandMark />
              <div className="flex flex-col">
                <span className="font-serif text-2xl font-semibold tracking-wide text-white">
                  Lithos
                  <span className="text-gold-500">.</span>
                </span>
                <span className="text-stone-500 text-[10px] font-sans uppercase tracking-[0.25em]">
                  Stone of Distinction
                </span>
              </div>
            </div>
            <p className="text-stone-400 text-sm font-sans leading-relaxed max-w-xs">
              Premium natural stone importer and distributor. Supplying premium marble, granite, and travertine to architects and construction professionals across Europe.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-sans text-sm font-semibold uppercase tracking-wider text-stone-300 mb-4">
              Navigation
            </h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: "Home", path: "/" },
                { label: "About Us", path: "/about" },
                { label: "Products", path: "/products" },
                { label: "Services", path: "/services" },
                { label: "Contact", path: "/contact" },
              ].map((item) => (
                <li key={item.path}>
                  <button
                    onClick={() => handleNav(item.path)}
                    className="text-stone-400 text-sm font-sans hover:text-gold-500 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-sans text-sm font-semibold uppercase tracking-wider text-stone-300 mb-4">
              Our Stones
            </h4>
            <ul className="flex flex-col gap-3">
              {[
                "Blanc Imperial Marble",
                "Gris Perle Marble",
                "Vert Emeraude Marble",
                "Premium Granite",
                "Quartzite",
                "Travertine",
              ].map((item) => (
                <li key={item}>
                  <span className="text-stone-400 text-sm font-sans">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-sans text-sm font-semibold uppercase tracking-wider text-stone-300 mb-4">
              Contact
            </h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-gold-500 text-sm"></i>
                </div>
                <span className="text-stone-400 text-sm font-sans">
                  contact@lithos.pro
                </span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-gold-500 text-sm"></i>
                </div>
                <span className="text-stone-400 text-sm font-sans">
                  +352 691 203 341
                </span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-gold-500 text-sm"></i>
                </div>
                <span className="text-stone-400 text-sm font-sans">
                  France
                </span>
              </li>
            </ul>
            <div className="flex gap-3 mt-6">
              <a
                href="#"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-stone-600 rounded-md text-stone-400 hover:text-gold-500 hover:border-gold-500 transition-colors"
              >
                <i className="ri-linkedin-fill text-sm"></i>
              </a>
              <a
                href="#"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-stone-600 rounded-md text-stone-400 hover:text-gold-500 hover:border-gold-500 transition-colors"
              >
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a
                href="#"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-stone-600 rounded-md text-stone-400 hover:text-gold-500 hover:border-gold-500 transition-colors"
              >
                <i className="ri-whatsapp-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-stone-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-stone-500 text-xs font-sans">
            © 2026 Lithos. All rights reserved.
          </p>
          <div className="flex gap-6">
            <button
              onClick={() => handleNav("/privacy")}
              className="text-stone-500 text-xs font-sans hover:text-stone-300 transition-colors cursor-pointer"
            >
              Privacy Policy
            </button>
            <button
              onClick={() => handleNav("/terms")}
              className="text-stone-500 text-xs font-sans hover:text-stone-300 transition-colors cursor-pointer"
            >
              Terms of Service
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}